<template>
  <div class="">
    <div v-if="onlyIcon">
      <i v-bind:class="getIconCls(accessType)" v-bind:style="'color: ' + getClr(accessType)" class="w3-large w3-left"
      :title="$t(accessType)">
        <span v-if="!onlyIcon"><b class="w3-margin-left w3-center">{{$t(accessType)}}</b></span>
      </i>
    </div>
    <div v-else>
      <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-large">
        <i v-bind:class="getIconCls(accessType)" v-bind:style="'color: ' + getClr(accessType)" class="w3-large w3-left">
          <span v-if="!onlyIcon"><b class="w3-margin-left w3-center">{{$t(accessType)}}</b></span>
        </i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccessTypeBadge",
  props: ['accessType', 'onlyIcon'],
  methods: {
    getIconCls(accessType) {
      return 'access-type-' + accessType + ' ' + this._getIconCls(accessType);
    },
    getClr(accessType) {
      switch (accessType) {
        case 'PATIENT':
          return "blue";
        case 'VISITOR':
          return "saddlebrown";
        case 'ACCOMPANY':
          return "deeppink";
        case 'FIRMA':
          return "darkorange";
        case 'TYPE_0':
          return "green";
      }
    },
    _getIconCls(accessType) {
      switch (accessType) {
        case 'PATIENT':
          return "fas fa-user-injured";
        case 'VISITOR':
          return "fas fa-dove";
        case 'ACCOMPANY':
          return "fa fa-heart";
        case 'FIRMA':
          return "fas fa-briefcase";
        case 'TYPE_0':
          return "fas fa-star";
      }
    }
  }
}

</script>

<style scoped>
</style>